import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import { gql, useMutation } from '@apollo/client';
import { Button } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation';
import { showAlert } from '../../../common/Alert/util';
const SYNC_TESTPRESS_EXAMS_MUTATION = gql`
  mutation SyncTestpressExams($examId: Float!) {
    syncTestpressExams(examId: $examId)
  }
`;

const SYNC_TESTPRESS_ATTEMPT_MUTATION = gql`
  mutation SyncOneTestpressExams($attemptId: Float! $userId: Float!) {
    syncOneTestpressExams(attemptId: $attemptId, userId: $userId)
  }
`;

const TestpressAttempts = () => {
  const [examId, setExamId] = useState('');
  const [attemptId, setAttemptId] = useState('');
  const [userId, setUserId] = useState('');
  const { translate } = useTranslation()
  const dispatch = useDispatch()
  const [syncExams, { loading }] = useMutation(SYNC_TESTPRESS_EXAMS_MUTATION);

  const [syncAttempt, { loading: attemptLoading }] = useMutation(SYNC_TESTPRESS_ATTEMPT_MUTATION);

  const handleSync = async (e) => {
    e.preventDefault();
    if (!examId) {
      showAlert({
        text: translate('testpressTool.addId'),
        status: 'error'
      }, dispatch)
      return;
    }

    try {

      await syncExams({
        variables: {
          examId: parseFloat(examId),
        },
      });
      showAlert({
        text: translate('testpressTool.syncSuccess'),
        status: 'success'
      }, dispatch)
    } catch (err) {
      console.error('Error al sincronizar los exámenes:', err);
      showAlert({
        text: translate('testpressTool.syncError'),
        status: 'error'
      }, dispatch)
    }
  };

  const handleSyncAttempt = async (e) => {
    e.preventDefault();
    if (!attemptId) {
      showAlert({
        text: translate('testpressTool.addId'),
        status: 'error'
      }, dispatch)
      return;
    }

    try {
      await syncAttempt({
        variables: {
          attemptId: parseFloat(attemptId),
          userId: parseFloat(userId),
        },
      });
      showAlert({
        text: translate('testpressTool.syncSuccess'),
        status: 'success'
      }, dispatch)
    } catch (err) {
      console.error('Error al sincronizar los attempts:', err);
      showAlert({
        text: translate('testpressTool.syncError'),
        status: 'error'
      }, dispatch)
    }
  };

  return (
    <div className='d-flex h-100 flex-column'>
    <div className='d-flex flex-column'>
      <h2 className='font-weight-bold'>{translate('testpressTool.title')}</h2>
      {/* <form onSubmit={handleSync}> */}
      <input className='col-6 mt-2'
        type="number"
        placeholder={translate('testpressTool.placeholder')}
        value={examId}
        onChange={(e) => setExamId(e.target.value)}
      />
      <Button
        color='primary'
        activity={loading}
        className='col-6 mt-2'
        label={translate('testpressTool.button')}
        onClick={handleSync}
        style={{ borderRadius: `${'16px 16px 16px 16px'}` }}>
      </Button>
      {/* </form> */}

    </div>
        <div className='d-flex flex-column mt-4'>
      <h2 className='font-weight-bold'>{translate('testpressTool.titleAttempt')}</h2>
      {/* <form onSubmit={handleSync}> */}
      <input className='col-6 mt-2'
        type="number"
        placeholder={translate('testpressTool.placeholderAttempt')}
        value={attemptId}
        onChange={(e) => setAttemptId(e.target.value)}
      />
      <input className='col-6 mt-2'
        type="number"
        placeholder={translate('testpressTool.placeholderUserId')}
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />
      <Button
        color='primary'
        activity={attemptLoading}
        className='col-6 mt-2'
        label={translate('testpressTool.button')}
        onClick={handleSyncAttempt}
        style={{ borderRadius: `${'16px 16px 16px 16px'}` }}>
      </Button>
      {/* </form> */}

    </div>
    </div>
  );
};

export default TestpressAttempts;
